import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { noop, Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { TeamRepository } from "../../../team/team.repository";
import { Team } from "../../../team/team.model";
import { UserService } from "app/user/user.service";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface TeamChangeEvent {
  originalEvent: MouseEvent;
  value: Team;
}

@Component({
  selector: "app-team-select",
  styleUrls: ["./team-select.component.scss"],
  templateUrl: "./team-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class TeamSelectComponent implements OnInit, OnChanges {
  private teamRepository = inject(TeamRepository);
  private userService = inject(UserService);

  public readonly teamChange = output<Team[]>();
  @Input() public team: Team = null;
  public readonly teamId = input<number>(null);
  public readonly disabled = input(false);
  public readonly required = input(false);

  public subscription = new Subscription();
  public teamList: SelectItem[] = [];
  public loaded = false;

  ngOnInit() {
    this.buildTeamList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.teamId()) {
      this.updateSelectedTeam();
    }
  }

  private updateSelectedTeam(): void {
    if (this.teamId() && this.teamList.length) {
      const exists = this.teamList.find(
        (item) => item.value.getId() == this.teamId(),
      );
      if (exists) {
        this.team = exists.value;
      }
    }
  }

  public onTeamChange(event: Team[]) {
    this.teamChange.emit(event);
  }

  private buildTeamList(): void {
    this.loaded = false;
    this.teamList = [];

    this.userService.getUser().then((user) => {
      const organizationId = user.getTeam().getOrganization().getId();
      this.teamRepository
        .listByOrganization(organizationId)
        .subscribe((teamList) => {
          teamList.forEach((team) => {
            this.teamList.push({ label: team.getName(), value: team });
          });
          this.updateSelectedTeam();
          this.loaded = true;
        });
    }, noop);
  }
}
